import type { ComponentProps } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { MLBBall } from '@sorare/core/src/atoms/icons/MLBBall';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { BrandXXS } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';
import { CornerBadge } from '@sorare/core/src/components/CornerBadge';

type Props = {
  color?: 'green' | 'grey';
  variant?: 'chip' | 'cornerBadge';
} & Pick<ComponentProps<typeof Chip>, 'size'>;

export const ProbablePitcher = ({
  color = 'green',
  size = 'medium',
  variant = 'chip',
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      title={formatMessage({
        id: 'ProbablePitcher.tooltip',
        defaultMessage: 'Probable Pitcher',
      })}
    >
      {variant === 'chip' ? (
        <Chip size={size} color={color}>
          <FormattedMessage id="ProbablePitcher.accronym" defaultMessage="PP" />
        </Chip>
      ) : (
        <CornerBadge color="var(--c-onBase-success)">
          <BrandXXS as={Horizontal} gap={0.5} bold color="var(--c-black)">
            <MLBBall color="var(--c-black)" size={1} />
            <FormattedMessage
              id="ProbablePitcher.accronym"
              defaultMessage="PP"
            />
          </BrandXXS>
        </CornerBadge>
      )}
    </Tooltip>
  );
};
